import React from "react";
import { Col, Row, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";

import { translate } from "../../../locale";
import PendingInvitationsTable from "../../../components/Tables/PendingInvitationsTable";

const { Title } = Typography;

const PendingInvitations = () => {
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 mt-10 mx-0 md:mx-10 px-4 md:px-0">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/admin/contacts">{translate("Contactos")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {translate("Invitaciones enviadas")}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center !text-lg md:!text-3xl">
            {translate("Invitaciones enviadas")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          <PendingInvitationsTable />
        </Col>
      </Row>
    </div>
  );
};

export default PendingInvitations;
